function save_cookie() {
  let key = 'WEB_CLIENT_ID';
  let c = decodeURIComponent(((document.cookie + ';').match(key + '=([^\\S;]*)') || [])[1]);
  if (c !== 'undefined') {
    document.cookie = key + '=' + c + ';max-age=94608000';
  } else {
    let e = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let len = 16;
    var r = '';
    for (var i = 0; i < len; i++) {
      r += e.charAt(Math.floor(Math.random() * e.length));
    }
    document.cookie = key + '=WEB_' + r + '_' + String(Date.now()) + '; max-age=94608000; path=/';
  }
}

function get_cookie() {
  var arr = new Array();
  if (document.cookie !== '') {
    var tmp = document.cookie.split('; ');
    for (var i = 0; i < tmp.length; i++) {
      var data = tmp[i].split('=');
      arr[data[0]] = decodeURIComponent(data[1]);
    }
  }
  return arr;
}

export {save_cookie, get_cookie};
